/** Polygon fill when manual or remote survey block reason is set (see {@link SeasonManager}). */
export const SEASON_SURVEY_BLOCKED_POLYGON_FILL = '#9e9e9e';
/** Polygon outline when survey is blocked. */
export const SEASON_SURVEY_BLOCKED_POLYGON_STROKE = '#212121';
/** Plan vs fact crop mismatch on the map. */
export const SEASON_PLAN_FACT_MISMATCH_COLOR = '#ef4444';
/** Outline for plan/fact mismatch polygons and legend swatch. */
export const SEASON_PLAN_FACT_MISMATCH_STROKE = '#000000';
/** Demo fact fill for plan/fact stripe legend swatch (default VT fill). */
export const SEASON_LEGEND_PLAN_FACT_SWATCH_FACT = '#4287f5';
/** Demo plan stripe for plan/fact stripe legend swatch. */
export const SEASON_LEGEND_PLAN_FACT_SWATCH_PLAN = '#9c27b0';

export type CropIdentificationPanelLegendKind =
  | 'crop'
  | 'surveyBlocked'
  | 'planFactCorrespondence'
  | 'planFactMismatch';

export interface CropIdentificationPanelLegendItem {
  nameKey: string;
  kind: CropIdentificationPanelLegendKind;
  color?: string;
}
